import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import useDateRangePicker from '../../../../../components/organisms/forms/date-range-picker/reusable-func';
import api from '../../../../../components/api';
import { Invoice } from '../hooks';
import clientByIdDummy from '../clientById.json';

function useClientInvoice() {
  /*
   *
   *
   *
   *
   *
   *
   *
   */

  /*
  * Get Initial Data
  * 1. param from url format : clients/invoice/:clientId
  * 2. Get clientName from clientId, clientName is needed for fetching invoices data
  */

  // 1. Get Params from url
  const { clientId } = useParams();

  // 2. Get Invoice by ClientName from AddHeader Component Text
  // 2.1. Get Client By Id
  const { data: clientByIdRes } = useQuery(
    ['getById', 'clients', clientId],
    () => api.clients.getById(clientId!),
    {
      enabled: !!clientId,
    },
  );

  // 2.2. Get Client Name from Client By Id Result Fetch
  const clientName: string | undefined = React.useMemo(() => {
    const resData: typeof clientByIdDummy | undefined = clientByIdRes?.data?.data;
    if (resData) return resData.name;
    return undefined;
  }, [clientByIdRes]);

  // 2.3. Get invoice list by clientName
  const { data: invoicesRes, isLoading: invoicesLoading } = useQuery(
    ['getServiceInvoicesByClientName', 'clients', clientName],
    () => api.clients.getServiceInvoicesByClientName(clientName!),
    {
      enabled: !!clientName,
    },
  );

  // 2.4. Filter Invoices list by search value
  const [searchValue, setSearchValue] = React.useState<string>('');
  const onChangeSearchValue = (text: string) => setSearchValue(text);

  // 2.5 Filter by DateRangePicker
  const { handleChangeStartDate, handleChangeEndDate, selectedDate } = useDateRangePicker();

  // 2.5 Result Invoices after filter and fetching
  const paidInvoiceList: Invoice[] | [] = React.useMemo(() => {
    const resData: Invoice[] | undefined = invoicesRes?.data?.data;
    if (resData) {
      console.log(resData.length);
      return resData.filter((paid) => {
        console.log(JSON.stringify(paid));
        const { paymentDate } = paid;
        const filterBySearch: boolean = JSON.stringify(paid).toLowerCase().includes(searchValue.toLowerCase());
        const filterByStartDate: boolean = new Date(new Date(paid.paymentDate).setDate(new Date(paid.paymentDate).getDate() - 1)).getTime() >= new Date(selectedDate.start).getTime();
        const filterByEndDate: boolean = new Date(new Date(paid.paymentDate).setDate(new Date(paid.paymentDate).getDate() - 1)).getTime() <= new Date(selectedDate.end).getTime();
        return paymentDate && filterBySearch && filterByStartDate && filterByEndDate;
      });
    }
    return [];
  }, [invoicesRes, searchValue, selectedDate]);

  return {
    handleChangeStartDate,
    handleChangeEndDate,
    onChangeSearchValue,
    searchValue,
    selectedDate,
    paidInvoiceList,
    invoicesLoading,
  };
}

export default useClientInvoice;
